import React from 'react';
import { Music, Users, Award } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">コンテストについて</h2>
          <div className="w-20 h-1 bg-blue-900 mx-auto"></div>
          <p className="mt-6 text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            大学対抗ピアノ演奏チームコンテストは、個人の技術だけでなく、チームとしての結束力と表現力を競う新しい形のコンクールです。
            各大学を代表するピアニストたちが集い、情熱と感動のステージを繰り広げます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border-2 border-blue-900 rounded-lg"></div>
            <img
              src="https://public.youware.com/users-website-assets/prod/42806107-9efa-4743-9602-d260f74d9046/970353c5cf2342acb7f62edb613447ed.jpg"
              alt="Students Silhouette"
              className="relative rounded-lg shadow-xl w-full h-auto object-cover z-10"
            />
          </div>
          <div className="space-y-8">
            <div className="flex items-start">
              <div className="flex-shrink-0 p-3 bg-blue-100 rounded-full text-blue-900">
                <Users size={28} />
              </div>
              <div className="ml-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">チームで挑む</h3>
                <p className="text-gray-600 leading-relaxed">
                  個人戦が主流のピアノコンクールにおいて、本大会は「チーム戦」を重視。
                  互いに切磋琢磨し、励まし合いながら一つの音楽を作り上げる喜びを共有します。
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 p-3 bg-blue-100 rounded-full text-blue-900">
                <Music size={28} />
              </div>
              <div className="ml-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">多彩なプログラム</h3>
                <p className="text-gray-600 leading-relaxed">ソロ演奏だけでなく、連弾など、多様な演奏形態での参加が可能。 ピアノの持つ無限の可能性と、アンサンブルの魅力を最大限に引き出します。</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 p-3 bg-blue-100 rounded-full text-blue-900">
                <Award size={28} />
              </div>
              <div className="ml-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">大学の誇りを胸に</h3>
                <p className="text-gray-600 leading-relaxed">
                  母校の看板を背負い、プライドをかけた熱い戦い。
                  他大学との交流を通じて、新たな音楽仲間との出会いも生まれます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
